export const API_URL = "https://api.politicki.ba/";
export default API_URL;


// WEBPACK FOOTER //
// ./src/common/config.js